import { BLUE_RIBBON_900, GRAYSCALE_200, GRAYSCALE_300, GRAYSCALE_500 } from '../../styles/colors';
import { GIVONIC, INTER } from '../../styles/fonts';
import styled from 'styled-components';

export const CarouselContainer = (styled.div`
  position: relative;
  width: 100%;
  margin: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const SlideContainer = (styled.div`
  width: 100%;
  overflow: hidden;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const Slides = (styled.div<{ $currentSlide: number }>`
  display: flex;
  transition: transform 0.5s ease;
  transform: translateX(-${(props) => props.$currentSlide * 100}%);
  width: 100%;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const Slide = (styled.div`
  min-width: 100%;
  position: relative;
  box-sizing: border-box;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const SlideContent = (styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 8px 12px;
  color: #333;
  box-sizing: border-box;
  width: 100%;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const SlideImage = (styled.img`
  width: 90%;
  max-width: 400px;
  max-height: 400px;
  margin-bottom: 14px;
  object-fit: contain;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const TextContainer = (styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const SlideTitle = (styled.h2`
  font-family: ${GIVONIC.bold};
  font-size: 18px;
  font-weight: 700;
  margin: 0px 0px;
  width: 100%;
  word-wrap: break-word;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const SlideDescription = (styled.p`
  font-family: ${INTER.regular};
  font-size: 13px;
  line-height: 1.5;
  color: ${GRAYSCALE_500};
  margin: 0px 0px 16px 0px;
  width: 100%;
  word-wrap: break-word;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const Indicators = (styled.div`
  display: flex;
  justify-content: center;
  bottom: 14px;
  width: 100%;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const Indicator = (styled.button<{ $active: boolean }>`
  width: ${(props) => (props.$active ? '10px' : '9px')};
  height: ${(props) => (props.$active ? '10px' : '9px')};
  border-radius: 50%;
  background-color: ${(props) => (props.$active ? BLUE_RIBBON_900 : GRAYSCALE_200)};
  border: 1px solid ${GRAYSCALE_300};
  margin: 0 5px;
  padding: 0;
  cursor: pointer;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
